import React from 'react';
import css from './ListingPage.module.css';
import classNames from 'classnames';
import { filters } from '../../marketplace-custom-config';

const SectionShortDescriptionMaybe = props => {
  const { publicData, phoneNumber, isOffer } = props;

  const startupAskOptions = filters.find(i => i.id === 'startupAsk').config.options;
  const fundingStatusOptions = filters.find(i => i.id === 'fundingStatus').config.options;
  const shortDescription = publicData?.shortDescription;

  // Hide capitalRaising option - point 12 https://redmine64.roobykon.com/issues/73379
  const startupAskArr = !!publicData?.startupAsk?.length && startupAskOptions?.filter(o1 => publicData?.startupAsk.find(o2 => o2 === o1.key))?.filter(o => o.key !== "capitalRaising");
  const fundingStatus = !!publicData?.fundingStatus && fundingStatusOptions.find(i => i.key === publicData?.fundingStatus);
  const startupAsk = !!startupAskArr.length && startupAskArr.map(i => i.label).join(', ');

  const isNoneSelected = publicData?.startupAsk?.find(option => option === 'none');

  return (
    <div className={css.sectionDescription}>
      {shortDescription && <div>
        <span className={css.label}>Business tag line:</span>
        <span className={classNames(css.value, { [css.valueNotTransformed]: isOffer })}>{shortDescription}</span>
      </div>}

      {startupAsk && !isNoneSelected && <div>
        <span className={css.label}>ASK first:</span>
        <span className={classNames(css.value, { [css.valueNotTransformed]: isOffer })}>{startupAsk}</span>
      </div>}

      {fundingStatus && <div>
        <span className={css.label}>Funding status:</span>
        <span className={classNames(css.value, { [css.valueNotTransformed]: isOffer })}>{fundingStatus.label}</span>
      </div>}
    </div>
  );
};

export default SectionShortDescriptionMaybe;
